import { create } from "zustand";

type Props = {
  digits: number;
  state: {
    phone: string;
    otpSent: boolean;
    otp: string;
    attempts: string;
    otpVerified: boolean;
  };
  loading: boolean;
  error: string;
  setLoading: (value: boolean) => void;
  setOtp: (value: string) => void;
  setError: (value: string) => void;
  setPhone: (value: string) => void;
  resetOtp: () => void;
  changePhone: () => void;
  otpSent: () => void;
};

const useAuth = create<Props>((set, get) => ({
  digits: 6,
  state: {
    phone: "",
    otpSent: false,
    otp: "",
    attempts: "0",
    otpVerified: false,
  },
  loading: false,
  error: "",
  setLoading: (value: boolean) => set({ loading: value }),
  setOtp: (value: string) => {
    const { state } = get();

    set({ state: { ...state, otp: value } });
  },
  setError: (value: string) => {
    const { state } = get();

    set({ error: value, state: { ...state, otpVerified: false } });
  },
  setPhone: (value: string) => {
    const { state } = get();

    set({ state: { ...state, phone: value } });
  },
  resetOtp: () => {
    const { state } = get();

    set({ state: { ...state, otp: "" } });
  },
  changePhone: () => {
    set({
      error: "",
      state: {
        phone: "",
        otpSent: false,
        otp: "",
        attempts: "0",
        otpVerified: false,
      },
    });
  },
  otpSent: () => {
    const { state } = get();

    set({
      error: "",
      state: {
        ...state,
        otpSent: true,
        attempts: (Number(state.attempts) + 1).toString(),
      },
    });
  },
}));

export default useAuth;
